import { render, staticRenderFns } from "./SearchCardCollection.vue?vue&type=template&id=dc24b0bc&scoped=true&"
import script from "./SearchCardCollection.vue?vue&type=script&lang=js&"
export * from "./SearchCardCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc24b0bc",
  null
  
)

export default component.exports